import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IProps, IState } from './types';
import service from 'bff/services/carProductService';
import _ from 'lodash';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
// import moment from 'moment';
import moment from 'moment-timezone';
import InsTypeDefines from 'constants/models/insTypeDefines';
import { InsType } from 'constants/enums/insType.enum';
import { SysOption } from 'bff/models/info';
import { SysOptParamId } from 'constants/enums/sysOptParamId.enum';
import { ApplyType } from 'constants/enums/applyType.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { PdfExportContent, CarSurveyNotify } from 'bff/models/product';
import { ExpType } from 'constants/enums/expType.enum';
import { PolicyDelivery } from 'constants/enums/policyDelivery.enum';
import { IVehicleOwnerInfoFormValue } from 'constants/models/components/insureProcessCar/vehicleOwnerInfo';
import { InsureProcessFillState } from 'constants/models/components/insureProcessCar/insureProcessFill';
import { RouterSettings } from 'constants/models/routerSettings';
import { withRouter } from 'react-router-dom';
import { VehicleItemType } from 'constants/enums/vehicleItemType';
import { PolicyItemListContent } from 'bff/models/product/vehicleItemList';
import { PayerContent } from 'bff/models/member/boPayby';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';
import { YesNoType } from 'constants/enums/yesNo.enum';
import { PaymentMethod } from 'constants/enums/paymentMethod.enum';
import { GameChkqualifyResp } from 'bff/models/game/gameChkqualify';
import { setGameQualifyModalVisibleAction } from 'redux/actions/modal.action';
import { GamePOI } from 'constants/enums/gamePOI.enum';
import gameService from 'bff/services/gameService';

class InsureProcessSuccess extends React.Component<IProps, IState> {
  state: IState = {
    insDoneCode: new Array(0),
    insDoneBarCode: new Array(0),
    emailNotifySysOpts: new Array(0),
    docIdSysOpts: new Array(0),
    applyType: '',
    policyDeliverySysOpts: new Array(0),
    barCodeUrl: ''
  }

  componentDidMount = async () => {
    commonService.scrollToTop();
    // 若繳費方式選擇行動條碼，且為網要時，取得繳費條碼路由
    const { tempPaymentFormValue } = this.props.tempPayment;
    const { tempFillState, tempFillFormValue } = this.props.tempFill;
    let barCodeUrl = '';
    if (
      tempPaymentFormValue &&
      tempFillState &&
      tempFillFormValue &&
      tempFillState.applyType === ApplyType.WebRequire &&
      tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode
    ) {
      barCodeUrl = await service.fetchBarcodeUrl(tempFillState.serialNo, tempFillFormValue.POLICYHOLDER_NAME);
    }

    // 補繳費
    if (
      tempPaymentFormValue &&
      tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode &&
      this.props.boPayby.APPLY_NO
    ) {
      const policyholders =
        _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);

      barCodeUrl = await service.fetchBarcodeUrl(this.props.boPayby.APPLY_NO, policyholders[0].NAME);
    }

    let applyType = '';
    if (this.props.boPayby.BC_TYPE) {
      applyType = this.props.boPayby.BC_TYPE;
    }

    if (tempFillState) {
      applyType = tempFillState.applyType;
    }

    const initSetting = await service.fetchInitSuccess();

    // 若是以帳戶轉帳或信用卡支付且有要保號，走到此頁視為「已繳款」，則查詢抽獎資格
    if (
      tempFillState &&
      tempFillState.serialNo &&
      tempPaymentFormValue &&
      (tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BankAccount || tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.CreditCard)) {
      const _applyNo = tempFillState.serialNo;
      const args = {
        GAMEPOI: GamePOI.INSURE,
        APPLY_NO: _applyNo
      };
      const response = await gameService.gameChkqualify(args);
      if (response && response.QUALIFIED_DCNT > 0) {
        // 顯示抽獎資格提示跳窗
        this.props.setGameQualifyModalVisible(true, GamePOI.INSURE, _applyNo, response);
      }
    }

    this.setState({
      applyType: applyType,
      insDoneCode: [...initSetting.insDoneCode],
      insDoneBarCode: [...initSetting.insDoneBarCode],
      emailNotifySysOpts: [...initSetting.emailNotifySysOpts],
      docIdSysOpts: [...initSetting.docIdSysOpts],
      policyDeliverySysOpts: [...initSetting.policyDeliverySysOpts],
      barCodeUrl: barCodeUrl
    });
  }

  /**
   * @description 取得網投完成訊息
   */
  handleWebInsuredSuccessMsg = () => {
    const { tempPaymentFormValue } = this.props.tempPayment;
    if (!tempPaymentFormValue) return;

    let applicantName;
    if (this.props.boPayby.APPLY_NO) {
      const insureds =
        _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      applicantName = insureds[0].NAME;
    }

    if (this.props.tempFill && this.props.tempFill.tempFillFormValue) {
      applicantName = this.props.tempFill.tempFillFormValue.POLICYHOLDER_NAME;
    }

    if (!applicantName) return;

    let msg = '';
    if (tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode) {
      msg = this.handleFormatBarMsg(CodeId.B001, moment().format('YYYY/MM/DD HH:mm'), InsTypeDefines[this.props.insTypeId as InsType]);
    }

    if (!msg) {
      msg = this.handleFormatMsg(CodeId.B001, moment().format('YYYY/MM/DD HH:mm'), InsTypeDefines[this.props.insTypeId as InsType]);
    }

    return (
      <p>
        {`親愛的${applicantName}您好：`}<br />
        <span>{commonService.htmlParser(msg)}</span>
      </p>
    );
  }

  /**
   * @description 取得網要完成訊息
   */
  handleWebRequireSuccessMsg = () => <p>{commonService.htmlParser(this.handleFormatMsg(CodeId.B005))}</p>

  /**
   * @description 取得投保完成訊息-需要勘車提醒
   */
  handleSuccessMsgCarInfo = () => {
    return (
      <p>{commonService.htmlParser(commonService.getCodeMsg(this.state.insDoneCode, CodeId.B004))}</p>
    );
  }

  /**
   * @description 取得投保完成訊息3
   */
  handleSuccessMsg4th = () => {
    const msg = this.handleGetSysMsg(this.state.emailNotifySysOpts, SysOptParamId.EMAIL_NOTIFY_CUSTOM_SERVICE);
    if (!msg) return null;

    let msgInfo: any = msg;

    if (msg.indexOf('：') !== -1) {
      const msgArray = msg.split('：');

      msgInfo = _.map(msgArray, (msg: string, index: number) => {
        return React.cloneElement(
          <>
            {msg} <br />
          </>
          , { key: index });
      });
    }

    return <p>{msgInfo}</p>;
  }

  /**
   * @description 取得 CodeTable 訊息，替換對應區塊值
  */
  handleFormatMsg = (codeId: string, ...params: any) => {
    const msg = commonService.getCodeMsg(this.state.insDoneCode, codeId);
    if (!msg) return '';

    return this.handleGetMsgInfo(msg, ...params);
  }

  /**
   * @description 付款方式為代碼繳費 取得 CodeTable 訊息，替換對應區塊值
  */
  handleFormatBarMsg = (codeId: string, ...params: any) => {
    const msg = commonService.getCodeMsg(this.state.insDoneBarCode, codeId);
    if (!msg) return '';

    return this.handleGetMsgInfo(msg, ...params);
  }

  /**
   * @description 取得顯示文字
   */
  handleGetMsgInfo = (msg: string, ...params: any) => {
    if (params && params.length > 0) {
      for (let i = 0; i < params.length; i += 1) {
        msg = msg.replace(`{#PARAM${i + 1}}`, params[i]);
      }
    }

    return msg;
  }

  /**
    *@description 取得系統參數值
    */
  handleGetSysMsg = (sysOpts: SysOption[], paramId: string) => {
    return _.find(sysOpts, (sysOpt: SysOption) => sysOpt.PARAM_ID === paramId)?.PARAM_VALUE;
  }

  /**
   * @description 取得保單寄送方式文字
  */
  handleGetDeliveryText = (type: string) => {
    return _.find(this.state.policyDeliverySysOpts, (sysOpt: SysOption) => sysOpt.PARAM_VALUE === type)?.PARAM_TEXT;
  }

  /**
   * @description 下載要保書
   */
  handleDownload = async () => {
    let serialNo;
    let prodId = '';
    if (this.props.boPayby.APPLY_NO) {
      serialNo = this.props.boPayby.APPLY_NO;
      prodId = this.props.boPayby.PROD_ID;
    }

    if (this.props.tempFill && this.props.tempFill.tempFillState && this.props.tempSelect && this.props.tempSelect.tempSelectState) {
      serialNo = this.props.tempFill.tempFillState.serialNo;
      prodId = this.props.insTypeId;
    }

    const docId = this.handleGetSysMsg(this.state.docIdSysOpts, prodId);

    const applyFormReqContent: PdfExportContent = {
      APPLY_NO: serialNo || '',
      DOC_ID: docId || '',
      EXPTYPE: ExpType.OnlyRequire
    };

    const fileUrl = await service.downloadApplyForm(applyFormReqContent);
    if (!fileUrl) return;

    let fileName = '';
    if (fileUrl.indexOf('/') !== -1) {
      const lastIndex = fileUrl.lastIndexOf('/');
      fileName = fileUrl.substring(lastIndex + 1);
    }

    try {
      commonService.downloadFile(fileUrl, fileName);
    } catch {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '下載失敗',
        html: '無法取得相關資訊'
      });
    }
  }

  /**
   * @description 開新分頁至繳費頁
  */
  handleRedirectBarcodePage = async () => {
    if (!this.state.barCodeUrl) return;

    window.open(this.state.barCodeUrl);
  }

  /**
   * @description 取得保單寄送方式參數值
  */
  handleGetDeliveryType = (delivery: string) => {
    return delivery === PolicyDelivery.Electric
      ? SysOptParamId.EMAIL_NOTIFY_PODELIVER_EPAPER
      : SysOptParamId.EMAIL_NOTIFY_PODELIVER_PAPER;
  }

  /**
   * @description 回傳是否需要勘車
  */
  handleCheckRequireSurvey = () => {
    if (this.props.boPayby.APPLY_NO) {
      return this.props.boPayby.CAR_SURVEY_STATUS !== YesNoType.No;
    }

    if (!this.props.tempSelect.tempSelectState) return;

    return this.props.tempSelect.tempSelectState.validVehicleInsRuleRes.REQUIRE_CAR_SURVEY;
  }

  /**
   * @description 勘車拍照按鈕 Click 事件
  */
  handleSurveyVehicleClick = async () => {
    let vehicleNo;
    let serialNo;
    if (this.props.boPayby.APPLY_NO) {
      vehicleNo = this.props.boPayby.CAR_LICENSE;
      serialNo = this.props.boPayby.APPLY_NO;
    }

    if (this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue && this.props.tempFill.tempFillState) {
      const vehicleOwnerInfoFormValue = { ...this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue } as IVehicleOwnerInfoFormValue;
      const fillState = { ...this.props.tempFill.tempFillState } as InsureProcessFillState;

      vehicleNo = `${vehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_FRONT}-${vehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_BACK}`;
      serialNo = fillState.serialNo;
    }

    if (!vehicleNo || !serialNo) return;

    // 若非行動裝置，提示錯誤訊息並不得繼續
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W032)
      });

      await this.handleCarSurveyNotify(serialNo, vehicleNo);

      return;
    }

    const path = {
      pathname: RouterSettings.SurveyVehicle,
      state: { applyNo: serialNo, vehiclePNo: vehicleNo }
    };

    this.props.history.push(path);
  }

  /**
   * @description 發送勘車簡訊(未完成)
  */
  handleCarSurveyNotify = async (serialNo: string, vehicleNo: string) => {
    const carSurveyNotifyReq: CarSurveyNotify = {
      APPLY_NO: serialNo,
      INS_TYPE_ID: this.props.insTypeId,
      VEHICLE_PNO: vehicleNo,
      // 固定帶入 NVCSF
      MSG_ID: 'NVCSF'
    };

    return await service.carSurveyNotify(carSurveyNotifyReq);
  }

  /**
   * @description 取得有投保的保障內容資料
  */
  handleFetchInsuredPolicys = (policyItemList: PolicyItemListContent[]) => {
    const insuredPolicy = new Array(0);

    _.forEach(policyItemList, (policyItem: PolicyItemListContent) => {
      _.forEach(policyItem.MAIN_ITEMS, (mainItem: any) => {
        if (mainItem.CHECKED) {
          insuredPolicy.push({
            ...mainItem,
            ITEM: mainItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(mainItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM: additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });

      _.forEach(policyItem.SUB_ITEMS, (subItem: any) => {
        if (subItem.CHECKED) {
          insuredPolicy.push({
            ...subItem,
            ITEM: subItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(subItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM: additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });
    });

    return insuredPolicy;
  }

  /**
   * @description 判斷是否包含判斷型態的投保項目
   */
  handleValidateHasType = (insuredPolicys: any, targetType: string) => {
    return _.findIndex(insuredPolicys, (insuredPolicy: any) =>
      insuredPolicy.CV_TYPE === targetType) !== -1;
  }

  /**
   * @description 取得要檢核用的生效日
   */
  handleGetInsuredDate = (hasCompulsory: boolean, hasArbitrary: boolean, compulsoryDate: any, arbitraryDate: any) => {
    const isCompulsoryDateValid = moment(compulsoryDate).isValid();
    const isArbitraryDateValid = moment(arbitraryDate).isValid();

    // 單獨強制險，判斷強制險預定生效日是否大於系統日 7 天後
    if (hasCompulsory && !hasArbitrary && isCompulsoryDateValid) {
      return moment(compulsoryDate);
    }

    // 單獨任意險，判斷任意險預定生效日是否大於系統日 7 天後
    if (!hasCompulsory && hasArbitrary && isArbitraryDateValid) {
      return moment(arbitraryDate);
    }

    // 強加任
    if (hasCompulsory && hasArbitrary && isCompulsoryDateValid && isArbitraryDateValid) {
      // 取 2 生效日最近的那個日期來比較
      const useDate = moment(compulsoryDate).isAfter(arbitraryDate)
        ? arbitraryDate
        : compulsoryDate;

      return moment(useDate);
    }
  }

  render () {
    const { tempPaymentFormValue } = this.props.tempPayment;
    const { tempFillState } = this.props.tempFill;
    /**
      * @description 依投保項目產生對應的投保日期顯示區塊
     */
    const handleGetInsuredDateInfo = () => {
      const resArray = new Array(0);
      let hasCompulsory;
      let hasArbitrary;
      let compulsoryInsYear;
      let compulsoryInsDate;
      let arbitraryDate;
      if (this.props.boPayby.APPLY_NO) {
        hasCompulsory = moment(this.props.boPayby.CO_START_DATE).isValid();
        hasArbitrary = moment(this.props.boPayby.VO_START_DATE).isValid();
        compulsoryInsYear = moment(this.props.boPayby.CO_START_DATE).isValid() && moment(this.props.boPayby.CO_END_DATE).isValid()
          ? `${moment(this.props.boPayby.CO_END_DATE).diff(moment(this.props.boPayby.CO_START_DATE), 'y')}`
          : '1';
        compulsoryInsDate = moment(this.props.boPayby.CO_START_DATE).isValid()
          ? this.props.boPayby.CO_START_DATE
          : '';
        arbitraryDate = moment(this.props.boPayby.VO_START_DATE).isValid()
          ? this.props.boPayby.VO_START_DATE
          : '';
      }
      const { tempSelectFormValue } = this.props.tempSelect;

      if (tempSelectFormValue) {
        const insuredPolicys = this.handleFetchInsuredPolicys(tempSelectFormValue.POLICY_ITEM);
        hasCompulsory = this.handleValidateHasType(insuredPolicys, VehicleItemType.CV_TYPE_CI);
        // 強制險投保年期
        compulsoryInsYear = tempSelectFormValue.COMPULSORY_INS_YEAR ? tempSelectFormValue.COMPULSORY_INS_YEAR : '1';
        compulsoryInsDate = tempSelectFormValue.COMPULSORY_INS_EFFECTIVE_DATE;
        hasArbitrary = this.handleValidateHasType(insuredPolicys, VehicleItemType.CV_TYPE_VI);
        arbitraryDate = tempSelectFormValue.ARBITRARY_INS_EFFECTIVE_DATE;
      }

      // 是否包含強制險項目
      if (hasCompulsory) {
        resArray.push(
          <p key={0}>
            {
              `強制險預定生效日：${moment(compulsoryInsDate).format('YYYY年MM月DD日')}中午12時起，保期${compulsoryInsYear === '1' ? '一' : '二'}年`
            }
          </p>
        );
      }

      // 是否包含任意險項目
      if (hasArbitrary) {
        resArray.push(
          <p key={1}>
            {
              `任意險預定生效日：${moment(arbitraryDate).format('YYYY年MM月DD日')}中午12時起，保期${compulsoryInsYear === '1' ? '一' : '二'}年`
            }
          </p>
        );
      }

      return resArray;
    };

    /**
     * @description 建立保障區塊
     */
    const handleGetInsuredContent = () => {
      let serialNo;
      let insuredName;
      let licenseNum;
      let fee;
      let delivery = '';
      if (this.props.boPayby.APPLY_NO) {
        serialNo = this.props.boPayby.APPLY_NO;
        const insureds =
          _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

        insuredName = insureds[0].NAME;
        licenseNum = this.props.boPayby.CAR_LICENSE;
        fee = this.props.boPayby.POLICY_FEE;
        delivery = this.props.boPayby.POLICY_DELIVERY;
      }

      const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;
      const { tempFillFormValue, tempFillState } = this.props.tempFill;
      const { tempSelectFormValue, tempSelectState } = this.props.tempSelect;

      if (tempVehicleOwnerInfoFormValue &&
        tempFillFormValue &&
        tempFillState &&
        tempSelectFormValue &&
        tempSelectState) {
        serialNo = tempFillState.serialNo;
        insuredName = tempFillFormValue.INSURED_NAME;
        licenseNum = `${tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_FRONT}-${tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_BACK}`;
        fee = commonService.getVehiclePrenium(tempSelectState.evalCarRes.SUMPREMIUM[1].SUMPREMIUM, tempSelectState.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI);
        delivery = tempFillFormValue.DELIVERY;
      }

      if (!serialNo || !insuredName || !licenseNum || !delivery) return;

      return (
        <>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">網路投保交易序號</div>
              <div className="element__list-group-content">{serialNo}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">被保險人姓名</div>
              <div className="element__list-group-content">{insuredName}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">車號</div>
              <div className="element__list-group-content">
                {licenseNum}
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">交易金額</div>
              <div className="element__list-group-content">{`NT$ ${commonService.thousandFormat(`${fee}`)}`}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">保單寄送方式</div>
              <div className="element__list-group-content">
                {
                  `${this.handleGetDeliveryText(delivery)}:${this.handleGetSysMsg(this.state.emailNotifySysOpts, this.handleGetDeliveryType(delivery))}`
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">保險期間</div>
              <div className="element__list-group-content">
                {
                  handleGetInsuredDateInfo()
                }
              </div>
            </div>
          </div>
        </>
      );
    };

    return (
      <div className="insure-process-success">
        {/* 投保完成 */}
        <div className="insured-complete">
          {this.props.insTypeId === InsType.Car && <img src="https://ensureuat.wwunion.com/ensure/images/Ah_want_I02.png" alt="汽車險投保完成示意圖" width={250} />}
          {this.props.insTypeId === InsType.Moto && <img src="https://ensureuat.wwunion.com/ensure/images/Ah_want_I03.png" alt="機車險投保完成示意圖" width={250} />}
          <div className="insured-complete__content">
            {
              this.state.applyType === ApplyType.WebInsured && !this.handleCheckRequireSurvey() && (
                <div className="insure-process-success__part">
                  {this.handleWebInsuredSuccessMsg()}
                </div>
              )
            }
            {
              this.state.applyType === ApplyType.WebRequire && !this.handleCheckRequireSurvey() && (
                <div className="insure-process-success__part">
                  {this.handleWebRequireSuccessMsg()}
                </div>
              )
            }
            {
              tempPaymentFormValue &&
              tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode && (
                <div className="insure-process-success__part">
                  <p>{commonService.htmlParser(commonService.getCodeMsg(this.state.insDoneBarCode, CodeId.B003))}</p>
                </div>
              )
            }
            {
              this.props.insTypeId === InsType.Car && this.handleCheckRequireSurvey() && (
                <>
                  {
                    this.handleSuccessMsgCarInfo()
                  }
                  <br />
                </>
              )
            }
          </div>
          {
            this.state.applyType === ApplyType.WebRequire && (
              <div className="insured-complete__controls">
                {
                  tempPaymentFormValue &&
                  tempPaymentFormValue.PAYMENT_METHOD !== PaymentMethod.BarCode && (
                    <button type="button" className="element__button element__button--red" onClick={this.handleDownload}>要保書下載</button>
                  )
                }
                {
                  tempPaymentFormValue &&
                  tempFillState &&
                  tempFillState.applyType === ApplyType.WebRequire &&
                  tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode && (
                    <button type="button" className="element__button element__button--red" onClick={this.handleRedirectBarcodePage}>繳費單連結</button>
                  )
                }
                {
                  tempPaymentFormValue &&
                  this.props.boPayby &&
                  this.props.boPayby.BC_TYPE &&
                  this.props.boPayby.BC_TYPE === ApplyType.WebRequire &&
                  tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode && (
                    <button type="button" className="element__button element__button--red" onClick={this.handleRedirectBarcodePage}>繳費單連結</button>
                  )
                }
                {
                  this.props.insTypeId === InsType.Car && this.handleCheckRequireSurvey() && (
                    <button
                      type="button"
                      className="element__button element__button--red"
                      onClick={this.handleSurveyVehicleClick}
                    >
                      勘車拍照
                    </button>
                  )
                }
              </div>
            )
          }
          {
            this.state.applyType === ApplyType.WebInsured && (
              <div className="insured-complete__controls">
                {
                  this.props.insTypeId === InsType.Car && this.handleCheckRequireSurvey() && (
                    <button
                      type="button"
                      className="element__button element__button--red"
                      onClick={this.handleSurveyVehicleClick}
                    >
                      勘車拍照
                    </button>
                  )
                }
              </div>
            )
          }
        </div>
        {/* 保險內容 */}
        <div className="insurance-content">
          <div className="insurance-content__title">保險內容</div>
          <div className="insurance-content__content">
            <div className="element__list">
              {
                handleGetInsuredContent()
              }
              <div className="element__list-col">
                {
                  tempPaymentFormValue &&
                  tempPaymentFormValue.PAYMENT_METHOD === PaymentMethod.BarCode && (
                    <div className="insure-process-success__part">
                      <p>{commonService.htmlParser(commonService.getCodeMsg(this.state.insDoneBarCode, CodeId.B004))}</p>
                    </div>
                  )
                }
                <div className="insure-process-success__part">
                  {this.handleSuccessMsg4th()}
                </div>
                {
                  tempPaymentFormValue &&
                  tempPaymentFormValue.PAYMENT_METHOD !== PaymentMethod.BarCode && (
                    <div className="insure-process-success__part">
                      <p>{commonService.htmlParser(commonService.getCodeMsg(this.state.insDoneCode, CodeId.B003))}</p>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setGameQualifyModalVisible:
    (visible: boolean, gamePoi: string, applyNo: string, checkResult: GameChkqualifyResp) =>
      dispatch(setGameQualifyModalVisibleAction(visible, gamePoi, applyNo, checkResult))
});

export default connect(null, mapDispatchToProps)(withRouter(InsureProcessSuccess));
